// extracted by mini-css-extract-plugin
export default {"criteria":"criteria_criteria__0JSZ6"};